import React from 'react';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'navy' | 'outline' | 'ghost' | 'link';
type Size = 'md' | 'lg';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  as?: 'button' | 'a';
  href?: string;
  variant?: Variant;
  size?: Size;
  full?: boolean;
}
const base = 'group/btn inline-flex min-h-[48px] items-center justify-center gap-2 rounded-btn font-body font-semibold transition-[transform,background-color,color,border-color,box-shadow] duration-200 ease-smooth focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60';
const sizes: Record<Size, string> = {
  md: 'px-6 py-3 text-[15px]',
  lg: 'px-7 py-3.5 text-[16px]'
};
const variants: Record<Variant, string> = {
  primary: 'bg-ct-cyan text-navy shadow-cyan hover:bg-ct-light hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0',
  navy: 'bg-navy text-white shadow-md hover:bg-navy-2 hover:-translate-y-0.5 hover:shadow-lg active:translate-y-0',
  outline: 'border border-border-strong bg-white text-ink shadow-sm hover:border-ct-cyan hover:text-ct-deep hover:-translate-y-0.5 hover:shadow-md active:translate-y-0',
  ghost: 'border border-white/20 bg-white/5 text-white backdrop-blur-sm hover:bg-white/15 hover:-translate-y-0.5',
  link: 'min-h-0 px-0 py-0 text-ct-deep hover:text-ct-cyan gap-1'
};
export function Button({
  as = 'button',
  href,
  variant = 'primary',
  size = 'md',
  full,
  className,
  children,
  ...rest
}: ButtonProps) {
  const cls = twMerge(base, variant !== 'link' && sizes[size], variants[variant], full && 'w-full', className);
  if (as === 'a') {
    return <a href={href} className={cls} {...rest as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-424" data-mp="1cf94c9lc5epi">
        {children}
      </a>;
  }
  return <button className={cls} {...rest} data-id="element-425" data-mp="1lecnteoezw4j">
      {children}
    </button>;
}